import { render, staticRenderFns } from "./SettlementsColumnAdjusterCard.vue?vue&type=template&id=5c6a40fa&"
import script from "./SettlementsColumnAdjusterCard.vue?vue&type=script&lang=js&"
export * from "./SettlementsColumnAdjusterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports